type Invert<M extends Record<keyof M, PropertyKey>> = {
  [K in keyof M as M[K]]: K;
};

export const createMappers = <M extends Record<keyof M, PropertyKey>>(
  map: M
) => {
  const invertedMap = (
    Object.entries(map) as Array<[PropertyKey, PropertyKey]>
  ).reduce(
    (inverted, [key, value]) => ({ ...inverted, [value]: key }),
    {}
  ) as Invert<M>;
  const leftToRight = <K extends keyof M>(from: K) => map[from];
  const rightToLeft = <K extends keyof Invert<M>>(to: K) => invertedMap[to];

  return [leftToRight, rightToLeft] as const;
};
